<template>
    <div class="tree-node">
        <div class="tree-children" :key="listItem.description" v-for="(listItem) in item.childNodes">
            <div v-if="listItem.childNodes && listItem.childNodes.length > 0" class="node-toggler"
                 @click.stop="listItem.active = !listItem.active">
                <i v-if="listItem.active" class="far fa-chevron-down p-0"></i>
                <i v-else class="far fa-chevron-right p-0"></i>
            </div>
            <div v-else class="node-toggler">
            </div>
            <div class="node-content"
                 v-if="listItem.Feature && listItem.Feature.Type && listItem.Feature.Type !== 'None'">
                <div class="node-name">
<!--                    <component :is="getType(listItem)"-->
<!--                               :value="values[listItem.Feature]"-->
<!--                               @input="updateValues(listItem.Feature, $event)">-->
<!--                    </component>-->

                    <div v-if="listItem.Feature.Type === 'ValueList' && !listItem.ValueId && listItem.childNodes && listItem.childNodes.length > 0">

                        <label @click.stop="listItem.active = !listItem.active">{{listItem.Feature.Description}}</label>

                    </div>
                    <div v-else-if="listItem.Feature.Type === 'ValueList' && !listItem.ValueId">

                        <v-select
                                @input="addFilterProperty(listItem.Feature, $event)"
                                class="secondary"
                                :placeholder="listItem.Feature.Description"
                                label="Description"
                                v-model="listItem.Feature.value"
                                :options="possibleValues(listItem.Feature.ValueListId).Values">
                        </v-select>

                    </div>
                    <div v-else-if="listItem.Feature.Type === 'ValueList' ">


                            <b-form-radio  @change="addFilterProperty(listItem.Feature, value(listItem.Feature.ValueListId,
                            listItem.ValueId))" :name="listItem.Feature.FeatureId">{{value(listItem.Feature.ValueListId,
                                listItem.ValueId).Description}}
                            </b-form-radio>
                            <!--</b-form-checkbox>-->
                            <!--{{value(listItem.Feature.ValueListId, listItem.ValueId).Description}}-->
                            <!--<div @click="addFilterProperty(listItem.Feature)">+</div>-->

                    </div>
                    <div v-else-if="listItem.Feature.Type === 'Logical'">
                        <b-form-checkbox @input="addFilterProperty(listItem.Feature, $event)" class="secondary">
                            {{listItem.Feature.Description}}
                        </b-form-checkbox>
                    </div>
                    <div v-else-if="listItem.Feature.Type === 'Numeric'">
                        <b-row>
                            <b-col class="m-auto"><label>{{listItem.Feature.Description}}:</label></b-col>
                            <b-col md="auto">
                                <b-input type="number" style="width:60px;height: 35px;" @input="addFilterProperty(listItem.Feature, $event)" class="secondary">
                                </b-input>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else-if="listItem.Feature.Type === 'TextShort' || listItem.Feature.Type === 'TextLong'">
                        <b-input @input="addFilterProperty(listItem.Feature, $event)"
                                 :placeholder="listItem.Feature.Description" class="secondary">
                        </b-input>
                    </div>
                    <img @error="$event.target.style.display='none'" class="gtl-img" v-if="listItem.ValueId" style="margin: auto; margin-left: 5px;"
                         :src="'https://gts.pranke.com/Pictures/' + listItem.ValueId"/>
                    <img @error="$event.target.style.display='none'" class="gtl-img" v-else style="margin: auto; margin-left: 5px;"
                         :src="'https://gts.pranke.com/Pictures/' + listItem.Feature.FeatureId"/>
                </div>


                <branch v-if="listItem.active" @add="$emit('add', $event)" :item="listItem" :key="listItem.Oid"/>
            </div>
            <div v-else>
                {{listItem.FeatureId}}
            </div>
        </div>
    </div>
</template>

<script>

    import GtlJson from '@shared/_assets/GTL.json';
    import numeric from "@client/src/viewsShop/pages/Gtl/components/numeric";
    import logical from "@client/src/viewsShop/pages/Gtl/components/logical";
    import text from "@client/src/viewsShop/pages/Gtl/components/text";
    import select from "@client/src/viewsShop/pages/Gtl/components/select";
    import radio from "@client/src/viewsShop/pages/Gtl/components/radio";

    export default {
        name: 'branch',
        props: {
            item: Object,
            values: {
                type: Array,
                default: () => []
            }
        },
        data: function () {
            return {
                isOpen: false,
                gtlJson: GtlJson,
                typeMapping: {
                    'TextShort': text,
                    'Logical': logical,
                    'Numeric': numeric,
                }
            };
        },
        computed: {
            hasChildren: function () {
                return this.item.childNodes && this.item.childNodes.length > 0;
            }
        },
        methods: {
            getType(item) {
                if(item.Feature.Type === 'ValueList') {
                    if(!item.ValueId) {
                        return select;
                    } else {
                        return radio;
                    }
                } else {
                    return this.typeMapping[item.Feature.Type];
                }
            },
            possibleValues(ValueListId) {
                return this.gtlJson.GTLCat.ValueLists.find(valueList => valueList.ValueListId === ValueListId);
            },
            value(ValueListId, ValueId) {
                return this.possibleValues(ValueListId).Values.find(v => v.ValueId === ValueId);
            },
            addFilterProperty(property, value) {
                property.value = value;
                this.$emit('add', property);
            },
            updateValues(feature, value) {
                this.$set(this.values, feature, value);
            }
        },
    };

</script>

<style lang="scss">
    .gtl-img {

        width: 26px;
        height: 26px;
        object-fit: cover;
        object-position: 50% 50%;

    }
</style>
